import { Box, styled } from "@mui/material";

const FolderName = styled(Box)(() => ({
  display: "inline-block",
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  maxWidth: "256px",
  height: "100%",
  paddingRight: "2px",
}))

export default FolderName
